import { Component, EventEmitter, HostListener, Input, OnInit, Output, SimpleChange, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ElectricComparatorResult } from 'src/app/components/account/models/ElectricComparatorResult';
import { ModalDocumentsComponent } from '../modal-documents/modal-documents.component';
import {environment} from "../../../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/internal/operators";
import {catchError} from "rxjs/operators";
import {forkJoin, of} from "rxjs";
import Swal from "sweetalert2";
import {FeignComparatorService} from "../services/feign.comparator.service";

@Component({
  selector: 'app-electric-comparator-table',
  templateUrl: './electric-comparator-table.component.html',
  styleUrls: ['./electric-comparator-table.component.scss']
})
export class ElectricComparatorTableComponent implements OnInit {

  @Input('comparatorForm') comparatorForm: FormGroup;
  @Input('electricComparatorResults') electricComparatorResults: ElectricComparatorResult[];

  public noCrt: string = "Nr. crt.";
  public supplier: string = "Denumire furnizor";
  public offerName: string = " Denumire ofertă";
  public offerType: string = "Tip ofertă";
  public details: string = "Detalii";
  public renewableEnergy: string = "Energie regenerabilă";
  public invoiceValue: string = "Valoare factură (lei)";
  public invoiceUnitValue: string = "Valoare unitară factură (lei/kwh)";
  public invoiceValueComparison: string = "Rezultat comparatie valoare factura oferta tip - valoare factura curenta (%)";
  public economyCost: string = "Economie/Cost suplimentar lunar (lei)";
  public comparisonResult: string = "Rezultat comparatie valoare facturi conform selectie";
  public suppliersComparison: string = "Selecție furnizori pentru comparație";
  public contractingInformation: string = "Informatii contractare";
  public energyTableNotification: string = "Valorile afisate in campul “Valoare factura (lei)” si “Valoare unitara factura (lei/kWh)” includ pretul energiei, valoarea componentei fixe (daca oferta contine acest element), tarifele reglementate pentru servicii (transport, serviciu de sistem si serviciul de distributie), contributia pentru cogenerare de inalta eficienta, contravaloarea certificatelor verzi, acciza si TVA-ul.";
  public selectedComparisonValues: any = [];
  public invoiceValueComparisonResult: any = [];
  public fillInTheCurrentInvoiceValue: string = "(completati valoare factura curenta)";
  public searchText: string;
  public searchLabelText: string = "Caută oferte-tip după furnizor";
  public comparisonResults: string = "Rezultate comparare";
  public comparisonSuppliers: any;
  public closeDetails: string = "Inchide detalii";
  public viewDetails: string = "Vezi detalii";
  public open: string = "Deschide";
  public equalValue: string = "Valoare egală";
  public selectOffer: string = "Selectează oferta";
  public isSelectOfferButtonVisible: boolean;
  public search: string = "Caută";
  public isMobileList: boolean;
  public sortBy: string;
  public sortDirection: string;

  @Output() searchEvent = new EventEmitter<string>();

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.isMobileList = window.innerWidth <= 991;
  }

  constructor(
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private comparatorService: FeignComparatorService
  ) {

    this.isMobileList = window.innerWidth <= 991;
    this.route.queryParams.subscribe(params => {
      if (Object.keys(params).length && (params.clientTypePF || params.clientTypePJ)) {
        this.isSelectOfferButtonVisible = true;
      } else {
        this.isSelectOfferButtonVisible = false;
      }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.electricComparatorResults) {
      this.initComparisonsuppliers();
    }
  }

  ngOnInit(): void {
    this.initComparisonsuppliers();
  }

  initComparisonsuppliers(): void {
    let nrCrt = 0;
    this.comparisonSuppliers = this.electricComparatorResults.map(function (a) {
      nrCrt++;
      let name = nrCrt + " - " + a.nume_furnizor + " - " + a.denumire_oferta;
      let value = a.valoare_factura_furnizor_fc;
      return {
        name: name,
        value: value
      };
    });
  }

  onExpandDetails(electricComparatorResult: any): any {
    electricComparatorResult.isSubRowDisplayed = !electricComparatorResult.isSubRowDisplayed;
  }

  onSort(column: string, direction: string): void {
    if (column === this.supplier) {
      if (direction == "up") {
        this.sortDirection = "up";
        this.electricComparatorResults.sort((a, b) => (a.nume_furnizor.trim() > b.nume_furnizor.trim()) ? 1 : ((b.nume_furnizor.trim() > a.nume_furnizor.trim()) ? -1 : 0));
      }
      if (direction == "down") {
        this.sortDirection = "down";
        this.electricComparatorResults.sort((a, b) => (a.nume_furnizor.trim() < b.nume_furnizor.trim()) ? 1 : ((b.nume_furnizor.trim() < a.nume_furnizor.trim()) ? -1 : 0));
      }
      this.sortBy = 'supplier';
    }
    if (column === this.invoiceValue) {
      if (direction == "up") {
        this.sortDirection = "up";
        this.electricComparatorResults.sort((a, b) => (this.onConvertToNumber(a.valoare_factura_furnizor_fc.replace(",", "")) > this.onConvertToNumber(b.valoare_factura_furnizor_fc.replace(",", "")) ? 1 : ((this.onConvertToNumber(b.valoare_factura_furnizor_fc.replace(",", "")) > this.onConvertToNumber(a.valoare_factura_furnizor_fc.replace(",", ""))) ? -1 : 0)));
      }
      if (direction == "down") {
        this.sortDirection = "down";
        this.electricComparatorResults.sort((a, b) => (this.onConvertToNumber(a.valoare_factura_furnizor_fc.replace(",", "")) < this.onConvertToNumber(b.valoare_factura_furnizor_fc.replace(",", "")) ? 1 : ((this.onConvertToNumber(b.valoare_factura_furnizor_fc.replace(",", "")) < this.onConvertToNumber(a.valoare_factura_furnizor_fc.replace(",", ""))) ? -1 : 0)));
      }
      this.sortBy = 'invoiceValue';
    }
    this.selectedComparisonValues = [];
    this.invoiceValueComparisonResult = [];
  }

  openDocumentsModal(electricComparatorResult: ElectricComparatorResult): void {
    const modalRef = this.modalService.open(ModalDocumentsComponent);
    modalRef.componentInstance.electricComparatorResult = electricComparatorResult;
  }

  onConvertToNumber(value: any, decimals?: number): number {
    if (!value) {
      return 0;
    }
    if (typeof value === 'string') {
      value = parseFloat(value.replace(",", ""));
    }
    return decimals ? parseFloat(value.toFixed(decimals)) : value;
  }

  onComputeInvoiceValueComparisonResult(selectedInvoiceValue: any, currentInvoiceValue: any, index: number): string {
    if (selectedInvoiceValue === null) {
      this.invoiceValueComparisonResult[index] = null;
      return;
    }
    selectedInvoiceValue = parseFloat(selectedInvoiceValue.replace(',', ''));
    currentInvoiceValue = parseFloat(currentInvoiceValue.replace(',', ''));
    let invoiceValueComparisonResult: number;
    if (selectedInvoiceValue > 0) {
      if (selectedInvoiceValue < currentInvoiceValue) {
        invoiceValueComparisonResult = -parseFloat((((currentInvoiceValue -
          selectedInvoiceValue) * 100) / selectedInvoiceValue).toFixed(2));
        this.invoiceValueComparisonResult[index] = invoiceValueComparisonResult;
      }
      if (selectedInvoiceValue === currentInvoiceValue) {
        this.invoiceValueComparisonResult[index] = this.equalValue;
      }
      if (selectedInvoiceValue > currentInvoiceValue) {
        invoiceValueComparisonResult = parseFloat((((selectedInvoiceValue -
          currentInvoiceValue) * 100) / currentInvoiceValue).toFixed(2));
        this.invoiceValueComparisonResult[index] = invoiceValueComparisonResult;
      }
    }
    return this.invoiceValueComparisonResult[index];
  }

  onDisplayOfferType(field: string): any {
    return {
      'bold': field === "Oferta concurentiala",
      'ofertaSu': field === "Oferta serviciu universal",
    };
  }

  saveOfferToStorage(electricComparatorResult: ElectricComparatorResult): void {
    localStorage.setItem('electricComparatorResult', JSON.stringify(electricComparatorResult));
  }

  checkAndSaveOfferToStorage(electricComparatorResult: ElectricComparatorResult): void {
    console.log('checkAndSaveOfferToStorage', electricComparatorResult);

    if (!electricComparatorResult.posf_ready) {
      Swal.fire({
        html: '<span>Oferta selectată nu prezintă datele tehnice necesare contractării/schimbării furnizorului direct prin intermediul POSF. ' +
          'Pentru a continua cu această ofertă vă rugăm să contactați furnizorul în scopul contractării/schimbării ' +
          'furnizorului prin mecanisme alternative puse la dispoziția dumneavoastră de către acesta.</span>',
        showConfirmButton: true,
        showCancelButton: false,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Anuleaza',
        customClass: {
          popup: 'popup-z-elevate-24-red popup-wide popup-with-list'
        }
      });
      return;
    }

    const documentTypes = this.comparatorService.getComparatorDocumentTypes(
      localStorage.getItem('comparatorType'),
      localStorage.getItem('supplierLicence'),
      localStorage.getItem('comparatorType') === 'electric' ? localStorage.getItem('electricComparatorResult')
        : (localStorage.getItem('comparatorType') === 'gas' ? localStorage.getItem('gasComparatorResult') : null),
      localStorage.getItem('clientTypePF') === 'true',
      localStorage.getItem('clientTypePJ') === 'true'
    );
    const documents = electricComparatorResult.documente
      .filter(x => x.fisier && x.fisier.trim())
      .filter(x => documentTypes.includes(x.tip_document));
    const modelContract = electricComparatorResult.model_contract;
    const fileLinks = [];
    if (documents && documents.length) {
      documents.forEach(doc => {
        const url = environment.comparatorDocumentsUrl + 'contracte/' + doc.fisier;
        fileLinks.push({url, name: doc.fisier, type: doc.tip_document});
      });
    }
    if (modelContract) {
      const url = environment.comparatorDocumentsUrl + 'furnizori/' + modelContract;
      fileLinks.push({url, name: modelContract, type: 'model_contract'});
    }
    console.log('fileUrls', fileLinks);
    const urlObservables = fileLinks.map(link => this.testUrl(link.url));
    const failedLinks = [];
    forkJoin(urlObservables).subscribe((results) => {
      results.forEach((result, index) => {
        if (!result) {
          failedLinks.push(fileLinks[index]);
        }
      });
      console.log('failedLinks', failedLinks);

      let popupMessage = '';
      if (failedLinks.length > 0) {
        popupMessage += '<span>Oferta selectată conține documente care nu pot fi accesate. ' +
          'Vă rugăm să contactaţi furnizorul pentru a actualiza documentele aferente sau pentru a contracta direct în baza ofertei selectate.</span>';
        popupMessage += '<br><span>Documente care nu pot fi accesate:</span><ul>';
        failedLinks.forEach(link => {
          popupMessage += `<li>${link.name || link.type}</li>`;
        });
        popupMessage += '</ul>';
      }

      if (popupMessage) {
        console.log('popupMessage', popupMessage);
        Swal.fire({
          html: popupMessage,
          showConfirmButton: true,
          showCancelButton: false,
          confirmButtonText: 'Confirm',
          cancelButtonText: 'Anuleaza',
          customClass: {
            popup: 'popup-z-elevate-24-red popup-wide popup-with-list'
          }
        });
        return;
      }

      this.saveOfferToStorage(electricComparatorResult);
      this.router.navigate(['utilizator','schimba-furnizor']);
    });
  }

  testUrl(url: string) {
    // Perform a HEAD request to check if the URL is accessible
    return this.http.head(url, { observe: 'response' }).pipe(
      map(() => true), // Return true if the request succeeds
      catchError(() => of(false)) // Return false if the request fails
    );
  }

  onSearch(): void {
    this.searchEvent.next(this.searchText);
  }

}
